package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.BoxSizing
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

// Layout global principal
val InfoLetterMainLayoutContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flex(1)
            .styleModifier {
                property("display", "flex")
                property("flex-direction", "column")
                property("overflow", "hidden")
            }
    }
    Breakpoint.LG {
        Modifier.styleModifier { property("flex-direction", "row") }
    }
}

// Conteneur de scroll du formulaire
val InfoLetterFormScrollContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flex(1)
            .padding(bottom = 50.px)
            .styleModifier {
                property("overflow-y", "auto")
                property("overflow-x", "hidden")
            }
    }
    Breakpoint.LG {
        Modifier.padding(bottom = 70.px)
    }
    Breakpoint.XL {
        Modifier.padding(bottom = 100.px)
    }
}

// Séparateur vertical entre Formulaire et Preview (Desktop uniquement)
val InfoLetterDividerStyle = CssStyle {
    base {
        Modifier
            .width(0.px)
            .styleModifier { property("display", "none") }
    }
    Breakpoint.LG {
        Modifier
            .width(1.px)
            .styleModifier {
                property("display", "block")
                property("background-color", "#2a2a3e")
                property("flex-shrink", "0")
            }
    }
}

// Panneau de prévisualisation (Visible uniquement à partir de LG)
val InfoLetterPreviewContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .styleModifier { property("display", "none") }
    }
    Breakpoint.LG {
        Modifier
            .flex(1)
            .styleModifier {
                property("display", "flex")
                property("flex-direction", "column")
                property("align-items", "center")
                property("overflow-y", "auto")
                property("overflow-x", "hidden")
            }
    }
}

val InfoMainLayoutContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flex(1)
            .styleModifier {
                property("display", "flex")
                property("flex-direction", "column")
                property("overflow", "hidden")
                property("min-height", "0")
            }
    }

    Breakpoint.LG {
        Modifier.styleModifier {
            property("flex-direction", "row")
        }
    }
}

val InfoFormScrollContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flex(1)
            .padding(bottom = 50.px)
            .styleModifier {
                property("overflow-y", "auto")
                property("overflow-x", "hidden")
                property("min-height", "0")
            }
    }

    Breakpoint.LG {
        Modifier.padding(bottom = 70.px)
    }

    Breakpoint.XL {
        Modifier.padding(bottom = 100.px)
    }
}

val InfoDividerStyle = CssStyle {
    base {
        Modifier
            .width(0.px)
            .styleModifier {
                property("display", "none")
            }
    }

    Breakpoint.LG {
        Modifier
            .width(1.px)
            .styleModifier {
                property("display", "block")
                property("background-color", "#2a2a3e")
                property("flex-shrink", "0")
            }
    }
}

val InfoPreviewContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .styleModifier {
                property("display", "none")
            }
    }

    Breakpoint.LG {
        Modifier
            .flex(1)
            .styleModifier {
                property("display", "flex")
                property("flex-direction", "column")
                property("align-items", "center")
                property("overflow-y", "auto")
                property("overflow-x", "hidden")
                property("min-height", "0")
            }
    }
}

// Barre de navigation
val NavigationBarContainerStyle = CssStyle {
    base {
        Modifier.height(58.px)
    }
    Breakpoint.SM {
        Modifier.height(68.px)
    }
}

val NavTitleTextStyle = CssStyle {
    base {
        Modifier.maxWidth(150.px)
    }
    Breakpoint.SM {
        Modifier.maxWidth(300.px)
    }
}
val HideOnMobileStyle = CssStyle {
    base {
        Modifier.styleModifier { property("display", "none") }
    }
    Breakpoint.LG {
        Modifier.styleModifier { property("display", "flex") }
    }
}

val downloadMobileOnlyStyle = CssStyle {
    base {
        Modifier.styleModifier { property("display", "flex") }
    }
    Breakpoint.LG {
        Modifier.styleModifier { property("display", "none") }
    }
}
val DesktopOnlyStylecss = CssStyle {
    base {
        Modifier.styleModifier {
            property("display", "none")
        }
    }

    Breakpoint.SM {
        Modifier.styleModifier {
            property("display", "flex")
        }
    }
}


val downloadDesktopOnlyStyle = CssStyle {
    base {
        Modifier.styleModifier { property("display", "none") }
    }
    Breakpoint.SM {
        Modifier.styleModifier { property("display", "none") }
    }
    Breakpoint.MD {
        Modifier.styleModifier { property("display", "none") }
    }
    Breakpoint.LG {
        Modifier.styleModifier { property("display", "flex") }
    }
}
/*

val downloadMobileOnlyStyle = CssStyle {
    base {
        Modifier.styleModifier { property("display", "flex") }
    }
    Breakpoint.SM {
        Modifier.styleModifier { property("display", "none") }
    }
    Breakpoint.MD {
        Modifier.styleModifier { property("display", "none") }
    }
    Breakpoint.LG {
        Modifier.styleModifier { property("display", "none") }
    }
    Breakpoint.XL {
        Modifier.styleModifier { property("display", "none") }
    }
}
*/
val MobileOnlyStylecss = CssStyle {
    base {
        Modifier.styleModifier {
            property("display", "flex")
        }
    }

    Breakpoint.SM {
        Modifier.styleModifier {
            property("display", "none")
        }
    }
}
val ShowOnlyOnMobileStyle = CssStyle {
    base {
        Modifier.styleModifier { property("display", "flex") }
    }
    Breakpoint.SM {
        Modifier.styleModifier { property("display", "none") }
    }
}

// Accordéon
val ReAccordionRowContainerStyle = CssStyle {
    base {
        Modifier.padding(leftRight = 16.px)
    }
    Breakpoint.MD {
        Modifier.padding(leftRight = 50.px)
    }
}

//val ReAccordionRowContentStyle = CssStyle {
//    base {
//        Modifier.padding(topBottom = 20.px)
//    }
//    Breakpoint.MD {
//        Modifier.padding(topBottom = 40.px)
//    }
//}
//
//val ReAccordionTitleTextStyle = CssStyle {
//    base {
//        Modifier.fontSize(15.px)
//    }
//    Breakpoint.MD {
//        Modifier.fontSize(25.px)
//    }
//}
//
//val ReAccordionActionPositionStyle = CssStyle {
//    base {
//        Modifier.right(15.px)
//    }
//    Breakpoint.MD {
//        Modifier.right(35.px)
//    }
//}
//
//val ReAccordionActionBoxStyle = CssStyle {
//    base {
//        Modifier.size(25.px)
//    }
//    Breakpoint.MD {
//        Modifier.size(35.px)
//    }
//}
//
//val ReAccordionActionIconStyle = CssStyle {
//    base {
//        Modifier.size(15.px)
//    }
//    Breakpoint.MD {
//        Modifier.size(20.px)
//    }
//}
//
//val ReAccordionPlusIconStyle = CssStyle {
//    base {
//        Modifier.size(20.px)
//    }
//    Breakpoint.MD {
//        Modifier.size(40.px)
//    }
//}

val AccordionContentPaddingStyle = CssStyle {
    base {
        Modifier.padding(left = 16.px)
    }
    Breakpoint.MD {
        Modifier.padding(left = 50.px)
    }
}

val TelechargerRowStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(right = 16.px)
            .styleModifier { property("align-items", "flex-end") }
    }
    Breakpoint.MD {
        Modifier.padding(right = 50.px)
    }
}

// Dynamic Button Sizing & Typography
val TelechargerButtonStyle = CssStyle {
    base {
        Modifier
            .margin(topBottom = 5.px)
            .height(42.px)
            .borderRadius(7.px)
            .padding(topBottom = 10.px, leftRight = 20.px)
            .fontSize(15.px)
            .styleModifier {
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
            }
    }
    Breakpoint.MD {
        Modifier
//            .height(42.px)
            .fontSize(18.px)
    }
}

val ReAccordionSectionPaddingStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .boxSizing(BoxSizing.BorderBox)
            .padding(leftRight = 16.px)
    }
    Breakpoint.MD {
        Modifier.padding(leftRight = 50.px)
    }
}

val ReAccordionRowContentStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(topBottom = 20.px)
    }
    Breakpoint.MD {
        Modifier.padding(topBottom = 40.px)
    }
}

val ReAccordionTitleTextStyle = CssStyle {
    base {
        Modifier.fontSize(15.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(25.px)
    }
}

val ReAccordionActionPositionStyle = CssStyle {
    base {
        Modifier.right(15.px)
    }
    Breakpoint.MD {
        Modifier.right(35.px)
    }
}

val ReAccordionActionBoxStyle = CssStyle {
    base {
        Modifier.size(25.px)
    }
    Breakpoint.MD {
        Modifier.size(35.px)
    }
}

val ReAccordionActionIconStyle = CssStyle {
    base {
        Modifier.fontSize(15.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(20.px)
    }
}

val ReAccordionPlusIconStyles = CssStyle {
    base {
        Modifier.fontSize(18.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(30.px)
    }
}

val ReAccordionPlusIconStyle = CssStyle {
    base {
        Modifier.size(24.px)
    }
    Breakpoint.MD {
        Modifier.size(36.px)
    }
}

val DropdownTriggerStyle = CssStyle {
    base {
        Modifier
            .size(30.px)
            .cursor(Cursor.Pointer)
    }

    Breakpoint.MD {
        Modifier
            .size(42.px)
    }
}

val DropdownTriggerIconStyle = CssStyle {
    base {
        Modifier.size(15.px)
    }

    Breakpoint.MD {
        Modifier.size(25.px)
    }
}